module.exports = __webpack_public_path__ + "images/emoji/u55b6.cfa2da1c9fe97c14c379.png";